import { useEffect, useState } from "react";
import "./AdminMenuCategorias.css";

function AdminMenuCategorias({ onAtualizarCategorias }) {
    const [categoriasBanco, setCategoriasBanco] = useState([]);
    const [categoriasMenu, setCategoriasMenu] = useState([]);
    const [filtro, setFiltro] = useState("");
    

    const carregarCategoriasMenu = async () => {
        try {
            const response = await fetch(
                "https://app.eliandroalimentos.com.br/api/categoriasmenu/listarcategoriasmenu"
            );

            const data = await response.json();

            setCategoriasMenu(data);
        } catch (error) {
            console.error(error);
        }
    };

    const carregarCategoriasBanco = async () => {
        try {
            const response = await fetch(
                "https://app.eliandroalimentos.com.br/api/categoriasmenu/listarcategoriasbanco"
            );

            const data = await response.json();

            setCategoriasBanco(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        carregarCategoriasBanco();
        carregarCategoriasMenu();
    }, []);

    const adicionarCategoria = async (categoria) => {
        try {
            await fetch(
                "https://app.eliandroalimentos.com.br/api/categoriasmenu/incluircategoriamenu",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        codgrupo: categoria.codgrupo,
                        descricao: categoria.descricao,
                    }),
                }
            );

            setFiltro("");

            carregarCategoriasMenu();

            if (onAtualizarCategorias) {
                onAtualizarCategorias();
            }
        } catch (error) {
            console.error(error);
        }
    };

    const removerCategoria = async (id) => {
        try {
            await fetch(
                "https://app.eliandroalimentos.com.br/api/categoriasmenu/deletarcategoriamenu",
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        id,
                    }),
                }
            );

            carregarCategoriasMenu();

            if (onAtualizarCategorias) {
                onAtualizarCategorias();
            }
        } catch (error) {
            console.error(error);
        }
    };

    const categoriasDisponiveis = categoriasBanco.filter(
        (cat) =>
            !categoriasMenu.some(
                (menu) => Number(menu.codgrupo) === Number(cat.codgrupo)
            )
    );

    const categoriasFiltradas = filtro
        ? categoriasDisponiveis.filter(
            (cat) =>
                cat.descricao
                    .toLowerCase()
                    .includes(filtro.toLowerCase()) ||
                String(cat.codgrupo).includes(filtro)
        )
        : [];

    const categoriasMenuOrdenadas = [...categoriasMenu].sort(
        (a, b) => a.descricao.localeCompare(b.descricao, "pt-BR")
    );

    return (
        <div className="admin-categorias">
            <h2>Editar Categorias do Menu</h2>

            <input
                type="text"
                placeholder="Digite descrição ou código..."
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
            />

            {categoriasFiltradas.length > 0 && (
                <div className="resultado-busca">
                    {categoriasFiltradas.slice(0, 15).map((cat) => (
                        <div
                            key={cat.codgrupo}
                            className="resultado-item"
                            onClick={() => adicionarCategoria(cat)}
                        >
                            {cat.codgrupo} - {cat.descricao}
                        </div>
                    ))}
                </div>
            )}

            <h3>Categorias do Menu</h3>

            <div className="lista-categorias-menu">
                {categoriasMenuOrdenadas.map((cat) => (
                    <div
                        key={cat.id}
                        className="categoria-menu-item"
                    >
                        <span>
                            {cat.codgrupo} - {cat.descricao}
                        </span>

                        <button
                            onClick={() => removerCategoria(cat.id)}
                        >
                            X
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AdminMenuCategorias;